import { useState } from "react";
import Textarea from "../../../../componentes/input/textarea";
import AcaoButtons from "../../Shared/AcaoButtons";

const OPCOES = [
    { value: true, label: "Sim, renovada", icone: "fa fa-check-circle" },
    { value: false, label: "Não renovada", icone: "fa fa-times-circle" },
];

/**
 * Etapa "Confirmação de Renovação" — Sim conclui a solicitação como renovada; Não exige
 * justificativa e encerra a solicitação como cancelada (mesmas regras do backend).
 * O PDF único dos documentos fica no detalhe da solicitação (DetalheRenovacaoGdm), visível em qualquer etapa.
 */
export default function EtapaRenovacaoGdmConfirmacao({ acoes = [], acaoEmExecucao, onExecutarAcao }) {
    const [renovado, setRenovado] = useState(null);
    const [justificativa, setJustificativa] = useState("");

    const valido = renovado === true || (renovado === false && !!justificativa.trim());

    function executar(acao) {
        if (!valido) return;
        onExecutarAcao(acao, {
            dados: {
                renovado,
                ...(renovado === false ? { justificativaNaoRenovacao: justificativa.trim() } : {}),
            },
        });
    }

    return (
        <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-1.5">
                <span className="text-sm font-medium text-foreground/80">
                    A GDM foi renovada? <span className="text-destructive">*</span>
                </span>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 max-w-lg">
                    {OPCOES.map(opcao => {
                        const ativo = renovado === opcao.value;
                        return (
                            <button
                                key={String(opcao.value)}
                                type="button"
                                aria-pressed={ativo}
                                onClick={() => setRenovado(opcao.value)}
                                className={`h-10 px-3 rounded-lg border text-sm font-medium inline-flex items-center justify-center gap-2 transition-colors ${ativo
                                    ? "bg-primary text-primary-foreground border-primary"
                                    : "bg-card text-foreground border-input hover:bg-muted"}`}
                            >
                                <i className={opcao.icone} />
                                {opcao.label}
                            </button>
                        );
                    })}
                </div>
            </div>

            {renovado === false && (
                <>
                    <Textarea
                        label="Justificativa da não renovação"
                        required
                        value={justificativa}
                        onChange={e => setJustificativa(e.target.value)}
                        rows={3}
                    />
                    <p className="text-xs text-muted-foreground -mt-2">A solicitação será encerrada como cancelada, com esse motivo.</p>
                </>
            )}

            <AcaoButtons acoes={acoes} acaoEmExecucao={acaoEmExecucao} onAcao={executar} disabled={!valido} />
        </div>
    );
}
